import type { FractionBalancePostingSpec } from '@festina/life-general-types/life'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { FractionBalancePostingSpecModal } from './FractionBalancePostingSpecModal'

type Props = {
  onSubmit: (fractionBalancePostingSpec: FractionBalancePostingSpec) => void
}

export const FractionBalancePostingSpecTableAction = ({ onSubmit }: Props) => {
  const translate = useTranslate()
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleSubmit = (
    fractionBalancePostingSpec: FractionBalancePostingSpec,
  ) => {
    onSubmit(fractionBalancePostingSpec)
    handleClose()
  }

  return (
    <>
      {isOpen && (
        <FractionBalancePostingSpecModal
          onSubmit={handleSubmit}
          onClose={handleClose}
        />
      )}
      <Button onClick={() => setIsOpen(true)}>
        {translate('action.addFractionBalancePosting.title')}
      </Button>
    </>
  )
}
